import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, RTL_LANGUAGES } from '@shared/i18n/config';
export function useLocale() {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    return {
        currentLang,
        isRTL: RTL_LANGUAGES.includes(currentLang),
        supportedLanguages: SUPPORTED_LANGUAGES,
        setLanguage: (lang) => i18n.changeLanguage(lang),
    };
}
